module.exports = "/_next/static/images/num-9-799f4f5f.png";